module.exports = __webpack_public_path__ + "static/img/Boyd-Cordner.c007fa6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Boyd-Cordner.jpg
// module id = Qvhp
// module chunks = 0